export default "__VITE_ASSET__hdYxeeGd__"